export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '5cd1c2a0-3197-4484-8f2e-a846b82212aa';
export const MODAL_CLOSE_SEC = 2.5;
